import React, { Component } from 'react';
import PropTypes from 'prop-types';

class KioskSeriesContainer extends Component {
    render() {
        return(
            <div className="kiosk__series-picker">
                {this.props.children}
            </div>
        )
    }
}

export default KioskSeriesContainer